app.controller("impactController", [
	"$scope",
	"CurrentPatient",
	"CurrentReferral",
	"$timeout",
	"ReferralsAPI",
	"$state",
	"$rootScope",
	"$modal",
	"IMPACT_ON_LIFE_VALID_MONTHS",
	function ($scope, CurrentPatient, CurrentReferral, $timeout, ReferralsAPI, $state, $rootScope, $modal, IMPACT_ON_LIFE_VALID_MONTHS) {
		$scope.RA = ReferralsAPI;
		$scope.CR = CurrentReferral;
		$scope.CP = CurrentPatient;

		$scope.impactOnLifeValidMonths = IMPACT_ON_LIFE_VALID_MONTHS;

		/**
		 * This screen opens in one of two states, decided by the answers the referral
		 * already carries:
		 *
		 * - Review. The answers are still inside the validity window, so they stand for
		 *   this referral. Show what was recorded and let the user decide: carry on to the
		 *   summary, or answer again because something has changed for the patient.
		 * - Answer. There is nothing usable: either the questions have never been asked, or
		 *   the answers have aged out and no longer describe the patient. The form is the
		 *   only way forward - an expired set is never offered back for review.
		 */
		$scope.showReview = $scope.CR.hasCurrentImpactOnLife();

		// Answering again is the user's call while the recorded set is still current. It
		// swaps the review for the form, the same form any other route into this screen
		// gets; nothing is written until it is submitted.
		$scope.answerAgain = function () {
			$scope.showReview = false;
		};

		// When the answers being reviewed were recorded, and - in the answer state - when
		// the expired set they are replacing was, which is what explains why the questions
		// are being asked again.
		$scope.answersDate = $scope.CR.impactOnLifeDate();
		$scope.expiredAnswersDate = $scope.CR.isImpactOnLifeExpired() ? $scope.answersDate : null;

		// The six areas of life, in the order the form asks about them, and the wording of
		// each answer. Both mirror the form below so a reviewed set reads the same as the
		// one that was filled in.
		var IMPACT_ON_LIFE_QUESTIONS = [
			{ key: "q1_socialInteraction", question: "Social Interactions" },
			{ key: "q2_personalInteraction", question: "Personal Relationships" },
			{ key: "q3_fulfillingResponsibilities", question: "Ability to meet your responsibilities to others" },
			{ key: "q4_personalCare", question: "Personal Care" },
			{ key: "q5_personalSafety", question: "Personal Safety" },
			{ key: "q6_leisureActivities", question: "Leisure Activities" },
		];

		var IMPACT_ON_LIFE_ANSWERS = {
			1: "No difficulty",
			2: "Little difficulty",
			3: "Some difficulty",
			4: "Quite difficult",
			5: "Very difficult",
			6: "Extremely difficult",
		};

		// A question the API sent no answer for is shown as unanswered rather than dropped,
		// so the review can't quietly lose one.
		var recordedAnswers = ($scope.CR.referral && $scope.CR.referral.cpacImpactOnLife) || {};
		$scope.reviewedAnswers = IMPACT_ON_LIFE_QUESTIONS.map(function (item) {
			var score = recordedAnswers[item.key];
			return {
				question: item.question,
				answer: IMPACT_ON_LIFE_ANSWERS[score] || "Not answered",
			};
		});

		$scope.continueToSummary = function () {
			$state.go("refer.complete");
		};

		$scope.popoverSocial = {
			title: "Social Interactions",
			content:
				"How much does your condition affect you social interactions? (Examples: meeting friends, going out, joining in groups, going shopping, everyday activities outside the home)",
		};

		$scope.popoverRelationship = {
			title: "Personal Relationships",
			content:
				"How much does your condition affect your personal relationships? (Examples: personal relations with partner, family members, close personal friends)",
		};

		$scope.popoverResponsibilities = {
			title: "Ability to meet your responsibilities to others",
			content:
				"How much does your condition affect your ability to meet your responsibilities to others? (Examples: doing meaningful things for yourself or others, including caring for children, grandchildren or partner; work (both paid and unpaid), including ‘having to rely on others’ may have an impact on you)",
		};

		$scope.popoverCare = {
			title: "Personal Care",
			content:
				"How much does your condition affect your personal care? (Examples: looking after yourself, your health, personal hygiene, need for aids or special clothing)",
		};

		$scope.popoverSafety = {
			title: "Personal Safety",
			content:
				"How much does your condition affect your personal safety? (Examples: being safe from injury and harm; from yourself, or others, and in your surroundings",
		};

		$scope.popoverLeisure = {
			title: "Leisure Activities",
			content:
				"How much does your condition affect your leisure activities? (Examples: getting exercise, hobbies, sporting activities, gardening, do-it-yourself activities, crafts, travel)",
		};

		$scope.warningHasShown = false;

		$scope.submit = function (values) {
			// Ignore a second press while the first submission is in flight.
			if ($scope.RA.isProcessing) {
				return false;
			}
			if ($scope.warningHasShown === false) {
				$scope.warningHasShown = true;
				return false;
			}

			$scope.RA.isProcessing = true;
			$scope.RA.impact(values).then(
				function (resp) {
					$scope.CR.setReferral(resp.data);
					// Only now have the questions actually been answered. Setting this on
					// arrival at the screen meant backing out of the form still counted as
					// having completed it.
					$scope.CP.eligibilitySummaryFirstLoad = false;
					$scope.RA.isProcessing = false;
					$state.go("refer.complete");
				},
				function (err) {
					console.error(err && err.status);
					$scope.RA.isProcessing = false;
				}
			);
		};
	},
]);
